
import WDElement from '../wd-element';
import WDDropdown from './wd-dropdown';
import WDChecklist from './wd-checklist';
import WDButton from '../button/wd-button';
import WDUtil from '../../core/wd-util';


/**
 * Gives us a grouped dropdown form.  This doesn't work with
 * fetch like our normal forms, and options must be passed
 * in a key => array format like:
 * options = [
 * 	{
 * 		label
 * 		name
 * 		options}]
 * 		"group1": [
 * 			{ label: 'Label 1', value:'value1'},
 * 			{ label: "Label 2", value:"value2"}
 * 		],
 * 		"group2": [
 * 			{ label: 'Label 1', value:'value1'},
 * 			{ label: "Label 2", value:"value2"}
 * 		]
 * }
 */
export default class WDDropdownGroupedForm extends WDElement
{
	#button = null;
	#checklists = [];

	#config = {
		options: {},
		allowClear: true,
		value: null,
		button: {
			label: 'Not Selected',
			prefix: null,
			theme: '',
			size: 'md',
			icon: null,
			update_text: true,
		},
	};

	constructor(opts)
	{
		//init
		super().classList.add('wd-dropdown-grouped-form', 'btn-group');

		//merge any passed parameters in
		if (opts) WDUtil.merge(this.#config, opts);

		//setup the button and base dropdown
		this.button;

		this.options = this.#config.options;
		this.value = this.#config.value;

		//this.tabIndex = -1;
		//this.addEventListener('keydown', (evt) => this.handleKeyDown(evt),true);

	};

	/*
	handleKeyDown(evt)
	{
		if (evt.key == 'ArrowDown')
		{
			//stop the dropdown from scrolling down
			if (evt.srcElement.classList.contains('wd-dropdown-grouped-form'))
			{
				if (this.#search) this.#search.focus();
				else if (this.options.length > 0)
				{
					this.items[0].focus();
					evt.preventDefault();
				}
			}
			else if (evt.srcElement.tagName.toLowerCase() == 'input')
			{
				if (this.options.length > 0)
				{
					this.items[0].focus();
					evt.preventDefault();
				}
			}
	
		}
		else if (evt.key == 'Enter')
		{
			evt.preventDefault();
			this.dropdown.hide();
		}
	};
	*/

	/** accessors **/
	get config() { return this.#config; };
	get options() { return this.#config.options; };
	set options(opts) { 

		this.#checklists = {};
		this.#config.options = opts;
		this.dropdown.replaceChildren();

		const curValue = this.value || {};

		//<li><h6 class="dropdown-header">Dropdown header</h6></li>
		opts.forEach( groupOption => {

			this.dropdown.append(wdc(`<div class="dropdown-header">${groupOption.label}</div>`));
			
			const val = typeof (curValue[groupOption.name]) != 'undefined' ? curValue[groupOption.name] : null;
			const cl = new WDChecklist({
				data: groupOption.options,
				value: val,
				icons: this.#config?.icons,
				separator: this.#config?.separator,
				allowClear: this.#config.allowClear,
			});

			this.bubbleEvents(cl,['change','input']);
			
			//allows us to update the button text
			cl.on('value:set', (evt) => 
			{
				this.updateButtonText();
				this.trigger('value:set', evt);
			});
			this.dropdown.append(cl);
			
			this.#checklists[groupOption.name] = cl;

		});

		this.updateButtonText();
	};

	get button()
	{
		if (!this.#button)
		{
			this.#button = new WDButton(this.#config.button);
			if (this.#config?.readonly || this.#config?.button?.disabled) this.#button.disabled = true;

			this.append(this.#button);

			//setup the dropdown
			this.#button.dropdown = new WDDropdown();
			this.#button.dataset.bsAutoClose = 'outside';
		}

		return this.#button;
	};

	set readonly(mode)
	{
		this.#button.disabled = mode;
	};

	get readonly() 
	{
		return this.#button.disabled;
	};

	/**
		  setup dropdown for results
		  */
	get dropdown()
	{
		return this.#button.dropdown;
	};


	get value() { 
		
		const value = {};
	
		Object.entries(this.#checklists).forEach( ([key, cl]) => {
			if (cl.value !== null) value[key] = cl.value;
		});
		
		return Object.keys(value).length > 0 ? value : null;

	};

	set value(val) { 

		const value = {};
		Object.entries(this.#checklists).forEach(([key, cl]) =>
		{
			cl.value = val && typeof(val[key]) != 'undefined' ? val[key] : null;
		});
	};

	/**
		  *
		  */
	updateButtonText()
	{
		const btnCfg = this.#config.button;

		//update the button text
		if (btnCfg?.update_text === false) return;

		const labels = [];
		Object.entries( this.#checklists ).forEach( ([key,cl]) => {

			if (cl.value !== null)
			{
				const curOpt = this.#config.options.find( opt => opt.name == key );
				const optVal = curOpt.options.find( x => x.value == cl.value );

				if (optVal)
				{
					const optLabel = optVal?.selectedLabel || optVal.label;
					labels.push(optLabel);
				}
				else
				{
					console.error('Could not find option value ',optVal);
				}
			}
		});
	
		this.button.label = labels.length > 0 ? labels.join(',') : btnCfg.label;

		//build a prefix and put it in front of our value
		if (this.#config?.button.prefix) 
		{
			const lblPrefix = wdc('<span/>');
			lblPrefix.append(this.#config.button.prefix);
			lblPrefix.classList.add('label-prefix');

			this.button.label.prepend(lblPrefix);
		}
	};

	cleanupCallback()
	{
		// Clean up button
		if (this.#button) {
			this.#button = null;
		}

		// Clean up all checklists
		if (this.#checklists) {
			this.#checklists = [];
		}

		// Clear config
		this.#config = null;

		super.cleanupCallback();
	}

};

customElements.define('wd-dropdown-grouped-form', WDDropdownGroupedForm);
